import PropTypes from "prop-types";
import { ImageSourcesType } from "../Image/types";

export const SpotlightType = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  source: PropTypes.string,
  fallbackImageSource: ImageSourcesType.isRequired,
  textTheme: PropTypes.string,
  bgColor: PropTypes.string,
  reverse: PropTypes.bool,
};
